import Button from "devextreme-react/button";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { FileTypes, ROType } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitChangeOrder } from "../api/submit-change-order";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function SubmitChangeOrderButton() {

	const navigate = useNavigate();
	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const submitChangeOrder = useSubmitChangeOrder(
		order.details.retailOrderID,
		order.details.changeOrderProducts,
		() => {
			showSuccessMessage('Change Order has been submitted');
			refetchOrder()
				.then(() => {
					const to = `/cfi/retail-order/${order.details.retailOrderID}/120` +
						(!!returnUrl ? '?returnUrl=' + returnUrl : '');

					navigate(to);
				})
		},
		(error) => showErrorMessage(error)
	)

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-submit-change' }}
				text="Submit Change"
				icon="Inscyth-Confirm"
				visible={true}
				disabled={submitChangeOrder.isLoading}
				onClick={() => {
					if (!order.details.isDeliveryOnly &&
						order.details.roTypeID !== ROType.CabinetMeasureOrder &&
						order.details.roTypeID !== ROType.CabinetInstallOrder &&
						order.details.roTypeID !== ROType.Plumbing &&
						!order.details.files.find(x => x.fileTypeID === FileTypes.PostTemplateDrawing)) {
						showErrorMessage("Please upload Post Template Drawing before submitting your order");
						return;
					}

					for (let product of order.details.changeOrderProducts) {
						if (product.dealerQty <= 0) {
							showErrorMessage('Quantity must be greater than 0');
							return;
						}
					}

					submitChangeOrder.mutate();
				}} >
			</Button>
			<LoadPagePanel visible={submitChangeOrder.isLoading}></LoadPagePanel>
		</>
	)
}
